import * as React from 'react';
import Popover from '@mui/material/Popover';
import Box from '@mui/material/Box';
import HelpIcon from '@mui/icons-material/Help';

/**
 * @param {Object} props
 * @param {string} [props.title='']
 * @param {Object|Array<*>} [props.content={}]
 * @param {string} [props.verticalOrigin='bottom']
 * @param {string} [props.horizontalOrigin='left']
 * @param {*} [props.Icon=HelpIcon]
 */
export default function MouseOverPopover({
  title = '',
  content = {},
  verticalOrigin = 'bottom',
  horizontalOrigin = 'left',
  Icon = HelpIcon,
}) {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <>
      <Icon
        aria-owns={open ? 'mouse-over-popover' : undefined}
        aria-haspopup="true"
        onMouseEnter={handlePopoverOpen}
        onMouseLeave={handlePopoverClose}
      />
      <Popover
        id="mouse-over-popover"
        sx={{
          pointerEvents: 'none',
        }}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: verticalOrigin,
          horizontal: horizontalOrigin,
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus
      >
        <Box sx={{ p: 2 }}>
          <div className="item-child-title">
            {title}
          </div>
          {content}
        </Box>
      </Popover>
    </>
  );
}
